import { useState } from "react";
import { Badge, DataTable, dateTime, money } from "layouts/finance/shared";
import AlertDialog from "./popup";

export default function DynamicTable({ filteredTransactions }) {
  const [selectedRow, setSelectedRow] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const view = (row) => {
    setSelectedRow(row);
    setIsOpen(true);
  };
  return (
    <>
      <DataTable
        rowKey="id"
        rows={filteredTransactions}
        columns={[
          {
            key: "id",
            label: "ID",
            render: (row) => (
              <button className="table-link" onClick={() => view(row)}>
                {row.id}
              </button>
            ),
          },
          { key: "merchantName", label: "Merchant" },
          { key: "merchantEmail", label: "Email" },
          {
            key: "amount",
            label: "Amount",
            render: (row) => money(row.amount),
          },
          { key: "paysureRef", label: "Reference" },
          {
            key: "transactionDate",
            label: "Date / time",
            render: (row) => dateTime(row.transactionDate),
          },
          { key: "channel", label: "Channel" },
          {
            key: "status",
            label: "Status",
            render: (row) => <Badge value={row.status} />,
          },
          {
            key: "action",
            label: "Details",
            render: (row) => (
              <button className="table-link" onClick={() => view(row)}>
                View transaction
              </button>
            ),
          },
        ]}
      />
      <AlertDialog
        row={selectedRow}
        isOpen={isOpen}
        handleClose={() => setIsOpen(false)}
        onClose={() => setSelectedRow(null)}
      />
    </>
  );
}
